import { oc } from '@orpc/contract';
import { applyTemplateInputSchema, estimateDetailSchema } from '../schemas/estimates.schemas.js';
/**
 * Replaces the template, version and policy references, the shared identity defaults and the reference
 * price, **keeps the facts the salesperson entered**, drops overrides the new version no longer allows
 * and returns the estimate to `DRAFT` (plan §7).
 */
export const applyEstimateTemplateContract = oc
    .route({
    method: 'POST',
    path: '/estimates/{estimateId}/apply-template',
    tags: ['Estimates'],
    summary: 'Apply another template’s published version to this estimate',
})
    .input(applyTemplateInputSchema)
    .output(estimateDetailSchema);
//# sourceMappingURL=apply-estimate-template.contract.js.map